import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App.js';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './Redux/store.js';


ReactDOM.render(<BrowserRouter>
                  <Provider store={store}>
                        <App />
                  </Provider>
                </BrowserRouter>
, document.getElementById("root"));